export const EnumCasesCategory: { [key: string]: string } = {
  memorialPark: "추모공원",
  funeral: "이장∙개장",
  tombConstruction: "묘 조성",
  landClearing: "벌초 대행",
};
